<!-- 境外生活 -->
<template>
  <div class="home">
    <h1>境外生活</h1>
  </div>
</template>

<script>
export default {
  name: "Home",
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
.content {
  margin: 0 auto;
  width: 100%;
  max-width: 75rem;
}
</style>
